import React from "react";
import { withRouter } from "react-router";
import IconSrc from '../resources/icon.png'
import {InputText} from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { PrimeIcons } from 'primereact/api';
import { Storage } from '@capacitor/storage';
import { v4 as uuidv4, v4 } from 'uuid';
import { backendUrl, postJson, getJson } from "../fetchFunctions";
import { error, success } from "../components/ToastController";
import { IonLabel, IonPage, IonSpinner, withIonLifeCycle } from "@ionic/react";
import { HTTP } from '@awesome-cordova-plugins/http/';
import { Dialog } from "primereact/dialog";

class Titlescreen extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            name: "",
            proceedEnabled: false,
            loading: false,
            creatingAccount: false,
            loadingLoggingInAsExistingUser: false,
            privateKey: "",
            showLogInModal: false
        }
    }

    ionViewWillEnter() {
        this.setState({creatingAccount: false, proceedEnabled: false, name: "", loading: true});

        Storage.get({key: 'clientId'}).then(clientId => {
            let params = new URLSearchParams(this.props.history.location.search);
            if(clientId.value && !params.has("dontAutoLogin"))
            {
                console.log("existing client id: " + clientId.value);
                this.props.history.push("app/tab1?id=" + clientId.value);
            }
            else this.setState({loading: false});
        }).catch((ex) => this.setState({loading: false}));
    }

    validateProceed = () => {
        let enabled = this.state.name.length > 0;
        this.setState({proceedEnabled: enabled});
    }

    onProceedClicked = async () => {
        this.setState({creatingAccount: true})
        //TODO Fetch request: Request user creation here with the given id, and the name
        let id = uuidv4();

        postJson("users/new", {
            privateKey: id,
            name: this.state.name
        }).then((response: any) => {
            if(response.ok) 
            {
                response.json().then((user: any) => {
                    if(user) {
                        console.log("user: ")
                        console.log(user);
                        Storage.set({key: "clientId", value: id}).then(() => {
    
                            Storage.set({key: "publicKey", value: user.publicKey}).then(() => {
                                let params = new URLSearchParams(this.props.history.location.search);
                                if (params.has("redirectTo")) {
                                    let path = params.get("redirectTo");
                                    this.props.history.push(path);
                                }
                                else {
                                    success("Du kan nu gå igang med at lave din ønskeliste", "Velkommen!")
                                    this.props.history.push("app/tab1?id=" + id);
                                }
    
                            })
                        })
                    }
                    else this.setState({creatingAccount: false})
                })
            }
            else 
            {
                response.text().then((text: any) => {
                    console.error("[users/new] error code " + response.status + ", msg: " + text)
                    error("Fejl Kode: " + response.status + ", " + text, "Fejl!")
                });
                this.setState({creatingAccount: false})
            }
        }).catch((ex: any) => error(ex));
    }

    onLogInAsExsistingUser = async () => {

        this.setState({loadingLoggingInAsExistingUser: true});
        let privateKey = this.state.privateKey;
        console.log("private Key: " + privateKey);
        getJson("users/get/private/" + privateKey).then((response: any) => {
            console.log("Got response", response);
            this.setState({loadingLoggingInAsExistingUser: false});
            if(response.ok) 
            {
                console.log("response: ", response);
                if((response.data && response.data.length === 0))
                {
                    error("Ugyldig Privat ID angivet", "Ugyldig")
                    return;
                }

                response.json().then((user: any) => {
                    if(user) {
                        console.log("user: ")
                        console.log(user);
                        Storage.set({key: "clientId", value: privateKey}).then(() => {
    
                            Storage.set({key: "publicKey", value: user.publicKey}).then(() => {
                                let params = new URLSearchParams(this.props.history.location.search);
                                if (params.has("redirectTo")) {
                                    let path = params.get("redirectTo");
                                    this.props.history.push(path);
                                }
                                else {
                                    success("Du kan nu gå igang med at lave din ønskeliste", "Velkommen!")
                                    this.props.history.push("app/tab1?id=" + privateKey);
                                }
                                this.setState({showLogInModal: false});
    
                            })
                        })
                    }
                })
            }
            else 
            {
                response.text().then((text: any) => error("Fejl Kode: " + response.status + ", " + text, "Fejl!"));
            }
        }).catch((ex: any) => error(ex));
    }

    render() {
        return (
            <IonPage>
                {this.state.loading ?
					<div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
						<IonSpinner style={{ width: "10vw", height: "10vw" }} color="tertiary" name="lines-sharp" />
					</div>
					:
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20vh"}}>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <img src={IconSrc} style={{width: "min(40vw, 250px)", height: "min(40vw, 250px)"}} />
                            </div>
                            <h1 style={{textAlign: "center", color: "#3567FF"}}>Ønskelisten</h1>

                            <div style={{display: "flex", justifyContent: "center", marginTop: "40px"}}>
                                <span className="p-float-label">
                                    <InputText id="in" value={this.state.name} onChange={(e) => this.setState({name: e.target.value}, this.validateProceed)} />
                                    <label htmlFor="in">Navn</label>
                                </span>
                            </div>


                            <div style={{display: "flex", justifyContent: "center", marginTop: "60px"}}>
                                <Button label="Fortsæt" loading={this.state.creatingAccount}  icon={PrimeIcons.ANGLE_RIGHT} iconPos="right" className="p-button-primary" disabled={!this.state.proceedEnabled} onClick={this.onProceedClicked} />
                            </div>
                            <div className="p-component" onClick={() => this.setState({showLogInModal: true})} style={{display: "flex", cursor: "pointer", justifyContent: "center", marginTop: "20px", color: "#3567ff", textDecoration: "underline", fontWeight: "bold"}}>
                                Log ind med eksisterende bruger
                            </div>


                            <Dialog header="Log Ind" visible={this.state.showLogInModal} onHide={() => this.setState({ showLogInModal: false })}>
								<div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                    <div className="p-component" style={{ color: "#777", display: "flex", maxWidth: "300px", justifyContent: "center", textAlign: "center" }}>
                                        Indtast her dit private ID fra din foregående konto. <br />Dette ID er vist inde under "Indstillinger" i appen.
                                    </div>

									<InputText autoFocus={true} style={{ marginTop: "16px" }} value={this.state.privateKey} placeholder="Privat ID" onChange={e => this.setState({ privateKey: e.target.value })} />

									<div style={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
										<Button onClick={this.onLogInAsExsistingUser} disabled={!this.state.privateKey ||this.state.privateKey.length === 0} loading={this.state.loadingLoggingInAsExistingUser} className="p-button-primary" style={{ marginRight: "20px" }} label="Log Ind" icon="pi pi-arrow-right" iconPos="right" />
									</div>
								</div>
							</Dialog>
                        </div>
                    }
            </IonPage>
            
        )
    }

}

export default withRouter(withIonLifeCycle(Titlescreen));